package com.macrofocus.high_d.parallelcoordinates

import com.macrofocus.high_d.axis.AxisView

/**
 * Default controller mediating user interactions with a ParallelCoordinatesView.
 */
class DefaultParallelCoordinatesController<Row, Column>(view: ParallelCoordinatesView<Row, Column>) : AbstractParallelCoordinatesController<Row, Column>() {
    override var view: ParallelCoordinatesView<Row, Column>? = null
        /**
         * {@inheritDoc}
         */
        set(view) {
            if (field != null) {
//                field!!.nativeComponent.removeKeyListener(keyListener)

                field!!.removeMouseListener(mouseListener)
                field!!.removeMouseMotionListener(mouseListener)

                field!!.removeDragListener(dragListener)
                field!!.removeHeaderListener(headerListener)
            }

            field = view

            if (view != null) {
//                view.nativeComponent.setFocusable(true)
//                view.nativeComponent.addKeyListener(keyListener)

                view.addMouseListener(mouseListener)
                view.addMouseMotionListener(mouseListener)

                view.addDragListener(dragListener)
                view.addHeaderListener(headerListener)
            }
        }

    private var draggedAxisView: AxisView<*, *>? = null

//    private val keyListener: KeyListener = object : KeyAdapter() {
//        var oldMode: InteractionMode? = null
//
//        override fun keyPressed(e: KeyEvent) {
//            if (e.keyCode == KeyEvent.VK_S) {
//                if (oldMode == null) {
//                    oldMode = getMode()
//                }
//                setMode(InteractionMode.Selection)
//            }
//        }
//
//        override fun keyReleased(e: KeyEvent) {
//            if (oldMode != null) {
//                setMode(oldMode!!)
//                oldMode = null
//            }
//        }
//    }

    /** Reorders the axes when their header is dragged, as SwingParallelCoordinatesController. */
    private val dragListener: ParallelCoordinatesView.DragListener = object : ParallelCoordinatesView.DragListener {
        override fun startDragging(axisView: AxisView<*, *>) {
            if (reordering.value) {
                draggedAxisView = axisView
                (view as? DefaultParallelCoordinatesView<Row, Column>)?.startAxisDrag(axisView)
            }
        }

        override fun dragAxisTo(axisView: AxisView<*, *>, location: Int) {
            if (reordering.value && draggedAxisView === axisView) {
                (view as? DefaultParallelCoordinatesView<Row, Column>)?.dragAxis(axisView, location)
            }
        }

        override fun stopDragging(axisView: AxisView<*, *>) {
            if (draggedAxisView === axisView) {
                draggedAxisView = null
                (view as? DefaultParallelCoordinatesView<Row, Column>)?.stopAxisDrag(axisView)
            }
        }
    }

    private val headerListener: ParallelCoordinatesView.HeaderListener =
        object : ParallelCoordinatesView.HeaderListener {
            override fun headerSelected(view: AxisView<*, *>, clickCount: Int) {
                if (clickCount == 2 && reversing.value) {
                    val axisModel = view.model
                    val start: Double = axisModel!!.scaledInterval.start
                    val end: Double = axisModel.scaledInterval.end
                    val max = axisModel.maximum
                    val min = axisModel.minimum
                    axisModel.setMinMax(max, min)
                    axisModel.scaledInterval.start = end
                    axisModel.scaledInterval.end = start
                }
            }
        }

    init {
        this.view = view
    }
}
